import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	priorityTooltip: {
		id: 'issue-field-priority-chip.common.priority-icon.priority-tooltip',
		defaultMessage: 'Priority: {name}',
		description: 'Tooltip of the priority icon when hovered over',
	},
});
